import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { MsalGuard } from '@azure/msal-angular'

const routes: Routes = [
  { path: '', pathMatch: 'full', loadChildren: () => import('@app/components/home/home.module').then(m => m.HomeModule) },
  // The MSAL redirect bridge lives at this path, but main.ts handles it before the app ever boots. Reaching
  // the router here means someone opened it without an authorization response, so send them home rather than
  // leave them on a dead url. Must stay outside the MsalGuard block below.
  { path: 'redirect', pathMatch: 'full', redirectTo: '' },
  {
    path: '',
    canActivateChild: [MsalGuard],
    children: [
      { path: 'viewer', loadChildren: () => import('@app/components/viewer/viewer.module').then(m => m.ViewerModule) },
      { path: 'search', loadChildren: () => import('@app/components/search/search.module').then(m => m.SearchModule) },
      { path: 'admin', loadChildren: () => import('@app/components/admin/admin.module').then(m => m.AdminModule) },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
